import Icon from "@/v2-ui/icon"
import type { IconNames } from "@/v2-ui/icon/icon.types"
import BaseTabs, {
  type TabsTriggerProps as BaseTabsTriggerProps,
} from "@/v2-ui/tabs"
import { useTabsState } from "./tabs.context"

export type TabsTriggerProps = BaseTabsTriggerProps & {
  isLoading?: boolean
  count?: number
  /** Leading glyph — drawn in both variants, but meant for sidebar lists. */
  iconSrc?: IconNames
}

function TabsTrigger(props: TabsTriggerProps) {
  const { isLoading, count, iconSrc, children, ...triggerProps } = props

  const isSidebar = useTabsState()?.variant === "sidebar"

  return (
    <BaseTabs.Trigger {...triggerProps}>
      {iconSrc && (
        <Icon src={iconSrc} size={14} className="ui-tabs-trigger-icon" />
      )}
      {/* In the sidebar variant the label flexes, pushing count/spinner to
          the right edge; horizontally the span is inert. */}
      <span className="ui-tabs-trigger-label">{children}</span>
      {isLoading ? (
        <Icon loading size={10} />
      ) : count === undefined ? null : (
        <span className="ui-tabs-trigger-count">
          {isSidebar ? count : `(${count})`}
        </span>
      )}
    </BaseTabs.Trigger>
  )
}

export default TabsTrigger
